import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  logList: {},
  logSummary: {},
  queueList: {},
  queueSummary: {},
  isLoading: true,
};

const notificationManagerSlice = createSlice({
  name: 'NotificationManager',
  initialState,
  reducers: {
    setNotificationLogList(state, action) {
      state.logList = action.payload;
      state.isLoading = false;
    },
    setNotificationLogSummary(state, action) {
      state.logSummary = action.payload;
    },
    setNotificationQueueList(state, action) {
      state.queueList = action.payload;
      state.isLoading = false;
    },
    setNotificationQueueSummary(state, action) {
      state.queueSummary = action.payload;
    },
  },
});

export const {
  setNotificationLogList,
  setNotificationLogSummary,
  setNotificationQueueList,
  setNotificationQueueSummary,
} = notificationManagerSlice.actions;

const notificationManagerReducer = notificationManagerSlice.reducer;

export default notificationManagerReducer;
